import './src/styles/global.css';

export const onClientEntry = () => {
  const cookieBannerId = process.env.GATSBY_COOKIE_BANNER_ID;
  if (!cookieBannerId) return;

  const autoBlock = document.createElement('script');
  autoBlock.type = 'text/javascript';
  autoBlock.src = `https://cdn.cookielaw.org/consent/${cookieBannerId}/OtAutoBlock.js`;
  document.head.appendChild(autoBlock);

  const sdkStub = document.createElement('script');
  sdkStub.src = `https://cdn.cookielaw.org/consent/${cookieBannerId}/otSDKStub.js`;
  sdkStub.type = 'text/javascript';
  sdkStub.setAttribute('charset', 'UTF-8');
  sdkStub.setAttribute('data-domain-script', cookieBannerId);
  sdkStub.onerror = () => {
    console.warn('OneTrust otSDKStub.js failed to load. Cookie banner may not be available.');
  };
  document.head.appendChild(sdkStub);

  const wrapper = document.createElement('script');
  wrapper.type = 'text/javascript';
  wrapper.innerHTML = 'function OptanonWrapper() {}';
  document.head.appendChild(wrapper);
};
